var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMskuItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7008_979",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7008_979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 11.6666L0.833328 6.66663L9.99999 1.66663L19.1667 6.66663L9.99999 11.6666ZM9.99999 15L1.31249 10.2708L3.06249 9.31246L9.99999 13.1041L16.9375 9.31246L18.6875 10.2708L9.99999 15ZM9.99999 18.3333L1.31249 13.6041L3.06249 12.6458L9.99999 16.4375L16.9375 12.6458L18.6875 13.6041L9.99999 18.3333ZM9.99999 9.77079L15.6875 6.66663L9.99999 3.56246L4.31249 6.66663L9.99999 9.77079Z",
    fill: "black",
    fillOpacity: 0.56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMskuItem);
export default __webpack_public_path__ + "static/media/icon-msku-item.93e398bf11595aa67ee5e47eb23c167e.svg";
export { ForwardRef as ReactComponent };